import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import { AppError } from "@/components/errors/app-error";
import { NotFound } from "@/components/errors/not-found";
import { localeRewrite } from "@/lib/locale";

// This is SSR router
export function getRouter() {
  const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    defaultErrorComponent: AppError,
    defaultNotFoundComponent: NotFound,
    scrollRestoration: true,
    rewrite: localeRewrite,
  });
  return router;
}
